import React, { useState, useEffect, useRef } from 'react';
import '../bbkandy/js/plugins/goodlayers-core/plugins/simpleline/simpleline.css'
import '../bbkandy/js/plugins/goodlayers-core/include/css/page-builder.css'

const KandySection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current; // Store the ref in a variable
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <>
      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;400;600&display=swap');

        .gdlr-core-pbf-column-content {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    min-height: 1px;
    padding : 105px 0px 36px 0px;
}

        .gdlr-core-title-item-title.slidertitle {
          font-family: 'Yellowtail', cursive !important;
          font-style: normal !important;
          font-weight: 400 !important;
          color: rgb(255, 255, 255) !important;
          font-size: 80px !important;
          line-height: 96px !important;
        }

        @media (max-width: 767px) {
          .gdlr-core-title-item-title.slidertitle {
            font-size: 48px !important;
            line-height: 56px !important;
          }
        }

        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .fade-in-left {
          opacity: 0;
        }

        .fade-in-right {
          opacity: 0;
        }

        .visible .fade-in-left {
          animation: fadeInLeft 600ms ease-out forwards;
        }

        .visible .fade-in-right {
          animation: fadeInRight 600ms ease-out forwards;
        }

        .bbkandybg {
          background-color: #f8f8f8;
          padding: 80px 0px 30px 0px !important; /* Reduced from 105px/36px */

        }

        .green_back {
          color: #3A4A26;
          background-color: #eeb85e;
          padding: 20px;
          border-radius: 30px;
        }

        .green_back_second {
          color: #3A4A26;
        }

        .bodyfont {
          font-family: 'Poppins', sans-serif;
          font-weight: 400;
          letter-spacing: 2px;
        }

        .gdlr-core-image-item-style-round {
          border-radius: 50px;
        }

        @media (max-width: 767px) {
          .gdlr-core-image-item-style-round {
            border-radius: 0;
          }
        }

        .desktopview {
          display: block;
        }

        .allphone {
          display: none;
        }

        @media (max-width: 767px) {
          .desktopview {
            display: none;
          }
          
          .allphone {
            display: block;
          }
        }

        .gdlr-core-button-transparent {
          background: transparent !important;
          border: none !important;
          padding: 0 !important;
        }

        .gdlr-core-button-transparent:hover {
          opacity: 0.8;
        }

        .icon-arrow-right {
          transition: transform 0.3s ease;
        }

        .gdlr-core-button-transparent:hover .icon-arrow-right {
          transform: translateX(5px);
        }

        .gdlr-core-left-align {
          text-align: left;
        }

        .gdlr-core-item-pdb {
          padding-bottom: 30px;
        }

        .gdlr-core-title-item .gdlr-core-title-item-title-wrap {
          position: relative;
        }

        .gdlr-core-pbf-column, .gdlr-core-pbf-column-content-margin {
          position: relative;
        }
      `}</style>

      <div
        className={`gdlr-core-pbf-wrapper bbkandybg ${isVisible ? 'visible' : ''}`}
        
        id="gdlr-core-wrapper-2"
        ref={sectionRef}
      >
        <div className="gdlr-core-pbf-background-wrap"></div>
        <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
          <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
            {/* First Column (Text Content) */}
            <div className="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first" id="gdlr-core-column-2">
              <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ padding: '30px 0px 0px 0px' }}>
                <div className="gdlr-core-pbf-background-wrap"></div>
                <div className={`gdlr-core-pbf-column-content clearfix gdlr-core-js fade-in-left`}>
                  <div className="gdlr-core-pbf-element">
                    <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                      <div
                        className="gdlr-core-text-box-item-content green_back bodyfont"
                        style={{ lineHeight: '1.4', fontWeight: 400, letterSpacing: '2px', textTransform: 'none', padding: '80px'}}
                      >
                        <p>
                          As the first luxury hostel in Kandy, we know how rewarding backpacking travel can be. It's serene, 
                          convenient and incredibly adventurous. Conveniently situated in the heart of Kandy and nestled 
                          within over 300 banana trees, Banana Bunks is a tropical sanctuary for all travel lovers.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-element">
                    <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                      <a
                        className="gdlr-core-button gdlr-core-button-transparent gdlr-core-left-align"
                        href="/BananaBunksKandy/aboutus"
                        id="gdlr-core-button-id-1"
                      >
                        <span className="gdlr-core-content green_back_second bodyfont">
                          More About Us
                          <i className="gdlr-core-pos-right icon-arrow-right" style={{ fontSize: '16px', color: '#3A4A26' }}></i>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Second Column (Desktop Image) */}
            <div className="gdlr-core-pbf-column gdlr-core-column-30 desktopview" id="gdlr-core-column-3">
              <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                <div className="gdlr-core-pbf-background-wrap"></div>
                <div className={`gdlr-core-pbf-column-content clearfix gdlr-core-js fade-in-right`}>
                  <div className="gdlr-core-pbf-element">
                    <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align" style={{ paddingBottom: '0px' }}>
                      <div
                        className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round2 gdlr-core-image-item-style-round"
                        style={{
                          borderWidth: '0px',
                          maxWidth: '550px',
                          borderRadius: '50px',
                          MozBorderRadius: '50px',
                          WebkitBorderRadius: '50px'
                        }}
                      >
                        <img src="/bbkandy/images/home/1-1.webp" alt="Banana Bunks Kandy" width="1000" height="1130" title="banana bunks" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Second Column (Mobile Image) */}
            <div className="gdlr-core-pbf-column gdlr-core-column-30 allphone" id="gdlr-core-column-4">
              <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                <div className="gdlr-core-pbf-background-wrap"></div>
                <div className={`gdlr-core-pbf-column-content clearfix gdlr-core-js fade-in-right`}>
                  <div className="gdlr-core-pbf-element">
                    <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align" style={{ paddingBottom: '0px' }}>
                      <div
                        className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round2 gdlr-core-image-item-style-round"
                        style={{
                          borderWidth: '0px',
                          maxWidth: '550px',
                          borderRadius: '0px',
                          MozBorderRadius: '0px',
                          WebkitBorderRadius: '0px'
                        }}
                      >
                        <img src="/bbkandy/images/home/mobile.png" alt="Banana Bunks Kandy Mobile" width="1000" height="1130" title="banana bunks" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Third Column (Group Image - Desktop only) */}
            <div className="gdlr-core-pbf-column gdlr-core-column-60 desktopview" id="gdlr-core-column-5">
              <div
                className="gdlr-core-pbf-column-content-margin gdlr-core-js"
                style={{ margin: '-130px 0px 0px 0px', padding: '0px 0px 0px 0px' }}
              >
                <div className="gdlr-core-pbf-background-wrap"></div>
                <div className={`gdlr-core-pbf-column-content clearfix gdlr-core-js fade-in-right`}>
                  <div className="gdlr-core-pbf-element">
                    <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align" style={{ paddingBottom: '0px' }}>
                      <div
                        className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round2 gdlr-core-image-item-style-round"
                        style={{
                          borderWidth: '0px',
                          maxWidth: '1500px',
                          borderRadius: '50px 0px 50px 0px',
                          MozBorderRadius: '50px 0px 50px 0px',
                          WebkitBorderRadius: '50px 0px 50px 0px',
                          paddingBottom: '0px'
                        }}
                      >
                        <img src="/bbkandy/images/home/group.png" alt="Banana Bunks Kandy Group" width="1381" title="banana bunks" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KandySection;